function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("style", null);
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 29C7.3 29 1 22.7 1 15S7.3 1 15 1s14 6.3 14 14-6.3 14-14 14zm0-25.5C8.7 3.5 3.5 8.7 3.5 15S8.7 26.5 15 26.5 26.5 21.3 26.5 15 21.3 3.5 15 3.5z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15 19.9c-1.4 0-2.9-.8-4-2.2-1-1.3-1.6-3-1.6-4.6 0-1.8.4-3.1 1.2-4.1 1-1.1 2.4-1.7 4.4-1.7 2 0 3.4.6 4.4 1.7.8 1 1.2 2.4 1.2 4.1 0 1.6-.6 3.3-1.6 4.6-1.1 1.4-2.6 2.2-4 2.2zm0-10.1c-1.2 0-2 .3-2.5.8-.4.5-.6 1.4-.6 2.5 0 1 .4 2.2 1.1 3.1.6.8 1.3 1.2 2 1.2s1.4-.4 2-1.2c.7-.9 1.1-2 1.1-3.1s-.2-2-.6-2.5c-.5-.5-1.3-.8-2.5-.8z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6 26c-.1-.2-2-4.2-6.6-4.2S8.5 25.9 8.4 26l-2.3-1c.1-.2 2.6-5.6 8.8-5.6 6.2 0 8.7 5.4 8.8 5.6l-2.1 1z"
});
function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _ref, _ref2, _ref3, _ref4);
}
export default SvgProfile;